export default {
  list: state => state.customerList,
  history: state => state.customerHistory,
}
